import { get, set, del } from 'idb-keyval';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';

export const QUERY_PERSISTENCE_KEY = 'REACT_QUERY_OFFLINE_CACHE';
export const PRIVATE_RUNTIME_CACHE_NAMES = ['api-runtime-cache'];

const CACHE_READ_TIMEOUT_MS = 2500;

function withTimeout(promise, timeoutMs) {
  let timeoutId;
  const timeout = new Promise((resolve) => {
    timeoutId = window.setTimeout(() => resolve(null), timeoutMs);
  });

  return Promise.race([promise, timeout]).finally(() => {
    window.clearTimeout(timeoutId);
  });
}

export const asyncStoragePersister = createAsyncStoragePersister({
  key: QUERY_PERSISTENCE_KEY,
  storage: {
    getItem: async (key) => {
      try {
        const value = await withTimeout(get(key), CACHE_READ_TIMEOUT_MS);
        return value === undefined ? null : value;
      } catch (error) {
        console.warn('Unable to restore query cache from IndexedDB:', error);
        return null;
      }
    },
    setItem: async (key, value) => {
      try {
        await set(key, value);
      } catch (error) {
        console.warn('Unable to persist query cache to IndexedDB:', error);
      }
    },
    removeItem: async (key) => {
      try {
        await del(key);
      } catch (error) {
        console.warn('Unable to remove query cache from IndexedDB:', error);
      }
    },
  },
});

export async function clearQueryPersistence() {
  await asyncStoragePersister.removeClient();
}

export async function clearPrivateRuntimeCaches() {
  if (!('caches' in window)) return;

  await Promise.allSettled(
    PRIVATE_RUNTIME_CACHE_NAMES.map((cacheName) => window.caches.delete(cacheName)),
  );
}
